
export default "/assets/eye-micro.9708ceb3.svg"